import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import {
  CheckboxDefinition,
  ICheckboxMapperProps,
  ICheckboxCarmiProps,
} from '../Checkbox.types';
import { props as viewerPropsMapper } from './Checkbox.mapper';

const props = composeMapper<
  PreviewWrapperProps<ICheckboxMapperProps>,
  CheckboxDefinition,
  ICheckboxCarmiProps
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState', 'shouldResetComponent', 'componentViewMode'],
    remove: [
      'fullNameCompType',
      'language',
      'compId',
      'mainPageId',
      'trackClicksAnalytics',
    ],
  },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);

    const { shouldResetComponent, compPreviewState, componentViewMode } =
      dependencies;

    return {
      ...viewerProps,
      trackClicksAnalytics: false,
      previewWrapperProps: {
        componentViewMode,
        shouldResetComponent,
        compPreviewState,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
